import React from "react";
import Section from "./Section";
import { X_PADDING } from "../constants";
import Page from "./Page";

const AwardCertificates = () => {
  return (
    <Page name="Awards and Certificates">
      <div className="w-full pt-8 bg-white">
        {/* Award and Certificates Section */}
        <Section
          name="Recognising Excellence"
          description="COAZ recognizes excellence among clinical officers in zambia through our awards and certification programs.
          Explore how we honor outstanding achievements and promote continuous professional development within our community."
        />

        {/* Coming Soon Image */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="relative w-full h-[400px] md:h-[500px] rounded-xl overflow-hidden shadow-lg">
            <div
              className="w-full h-full bg-cover bg-center"
              style={{ backgroundImage: "url(/images/img_15.jpg)" }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1a2e]/80 to-[#1477c2]/40"></div>
            </div>

            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <h2 className="text-5xl md:text-7xl font-nunitoSansBold text-white tracking-wider uppercase">
                COMING SOON
              </h2>

              <div className="w-24 h-1 bg-white/60 rounded-full mt-4"></div>

              <p className="text-white/80 text-sm md:text-base font-nunitoSansRegular mt-4 tracking-wider">
                Awards &amp; Certificates
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default AwardCertificates;
